module.exports = __webpack_public_path__ + "static-m/img/z1.f659539d.jpg";